import createReducer from "./createReducer";
import { ASSET_TYPES, SUPPRESS_SUCCESS_GROWL, SUPPRESS_ALL_GROWL } from "utils/constants";

export const VERSION_DETAILS_ACTIONS ={
	LOAD_VERSION_VARIABLES_AJAX: "LOAD_VERSION_VARIABLES_AJAX",
	CLEAR_VERSION_VARIABLES: "CLEAR_VERSION_VARIABLES",
	SET_VARIABLE_SEARCH_TERM: "SET_VARIABLE_SEARCH_TERM",
	LOAD_VERSION_VARIABLES_SUCCESS: "LOAD_VERSION_VARIABLES_SUCCESS",
	LOAD_VERSION_VARIABLES_ERROR: "LOAD_VERSION_VARIABLES_ERROR",

	SELECT_VERSION_TYPES:"SELECT_VERSION_TYPES",

	FETCH_VERSION_BY_NAME: "FETCH_VERSION_BY_NAME",
	FETCH_VERSION_BY_NAME_SUCCESS: "FETCH_VERSION_BY_NAME_SUCCESS",
	FETCH_VERSION_BY_NAME_ERROR: "FETCH_VERSION_BY_NAME_ERROR",

	FETCH_VERSION_INFO_AJAX:"FETCH_VERSION_INFO_AJAX",
	FETCH_VERSION_INFO_SUCCESS:"FETCH_VERSION_INFO_SUCCESS",
	FETCH_VERSION_INFO_ERROR:"FETCH_VERSION_INFO_ERROR",

	UPDATE_VERSION_VARIABLES_AJAX:"UPDATE_VERSION_VARIABLES_AJAX",
	UPDATE_VERSION_VARIABLES_SUCCESS:"UPDATE_VERSION_VARIABLES_SUCCESS",
	UPDATE_VERSION_VARIABLES_ERROR:"UPDATE_VERSION_VARIABLES_ERROR",
};

/**
 * This function is poorly named
 * This grabs the *variables* which does not include any of the top level version infomation
 */
export function loadVersionDetails(libraryId, creativeId, versionId){
	return (dispatch) => {
		return dispatch({
			type: VERSION_DETAILS_ACTIONS.LOAD_VERSION_VARIABLES_AJAX,
			meta:SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives/${creativeId}/versions/${versionId}/variables`,
				success: VERSION_DETAILS_ACTIONS.LOAD_VERSION_VARIABLES_SUCCESS,
				error: VERSION_DETAILS_ACTIONS.LOAD_VERSION_VARIABLES_ERROR,
			},
		});
	};
}

/**
 * getVersionInfo()
 * 	Gets the version detail information (does not include the variables)
 * @param  {id} versionId the version id
 */
export function getVersionInfo(versionId){
	return (dispatch) => {
		return dispatch({
			type: VERSION_DETAILS_ACTIONS.FETCH_VERSION_INFO_AJAX,
			meta: SUPPRESS_SUCCESS_GROWL,
			AJAX: {
				url: `versions/${versionId}`,
				success: VERSION_DETAILS_ACTIONS.FETCH_VERSION_INFO_SUCCESS,
				error: VERSION_DETAILS_ACTIONS.FETCH_VERSION_INFO_ERROR,
			},
		});
	};
}

export function fetchVersionByName(libraryId, creativeId, newVersionName){
	return (dispatch) => {
		let advancedFilter = `all(eq(name,${newVersionName}))`;

		return dispatch({
			type: VERSION_DETAILS_ACTIONS.FETCH_VERSION_BY_NAME,
			meta:  SUPPRESS_ALL_GROWL,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives/${creativeId}/versions`,
				params: { advancedFilter },
				success: VERSION_DETAILS_ACTIONS.FETCH_VERSION_BY_NAME_SUCCESS,
				error: VERSION_DETAILS_ACTIONS.FETCH_VERSION_BY_NAME_ERROR,
			},
		}).then((response) => {
			if(response?.success){
				let version = response.payload?.data?.items?.[0];
				return Promise.resolve(version);
			}
			return null; /*
				Let the promise resolve with a null, so that if the request times out or something,
				it doesn't hang the UI by leaving buttons disabled waiting for `asyncValidating` to be false.

				This will let you potentially submit with duplicate Version names, but the API should
				return an error.
			*/
		});
	};
}

export function updateVersionVariables(libraryId, creativeId, versionId, variablesArray, isDirty = false){
	return (dispatch) => {
		let meta = {};

		if(isDirty){
			meta = {
				...SUPPRESS_SUCCESS_GROWL,
			};
		}

		return dispatch({
			type: VERSION_DETAILS_ACTIONS.UPDATE_VERSION_VARIABLES_AJAX,
			meta,
			AJAX: {
				url: `creative-libraries/${libraryId}/creatives/${creativeId}/versions/${versionId}/variables`,
				params:{ dirty: isDirty },
				method: 'post',
				data: variablesArray,
				success: VERSION_DETAILS_ACTIONS.UPDATE_VERSION_VARIABLES_SUCCESS,
				error: VERSION_DETAILS_ACTIONS.UPDATE_VERSION_VARIABLES_ERROR,
			},
		});
	};
}


export function clearVersionDetails(){
	return ((dispatch) =>{
		dispatch({
			type: VERSION_DETAILS_ACTIONS.CLEAR_VERSION_VARIABLES,
		});
	});
}

export function setVariableSearchTerm(term){
	return ((dispatch) =>{
		dispatch({
			type:VERSION_DETAILS_ACTIONS.SET_VARIABLE_SEARCH_TERM,
			payload:term,
		});
	});
}

export function selectVersionType(type){
	return ((dispatch) =>{
		dispatch({
			type:VERSION_DETAILS_ACTIONS.SELECT_VERSION_TYPES,
			payload:type,
		});
	});
}

export const initialVersionDetailsState = {
	items:[],
	isLoaded: false,
	hasErrorLoading: false,
	searchTerm:"",
	selectedTypes: [],
	isSavingVariables:false,
};

export const actionCreators ={
	loadVersionDetails,
	fetchVersionByName,
	clearVersionDetails,
	setVariableSearchTerm,
	selectVersionType,
};

export const handlers = {
	[VERSION_DETAILS_ACTIONS.LOAD_VERSION_VARIABLES_AJAX]: initVersionDetails,
	[VERSION_DETAILS_ACTIONS.CLEAR_VERSION_VARIABLES]: clearedVersionDetails,

	[VERSION_DETAILS_ACTIONS.LOAD_VERSION_VARIABLES_SUCCESS]: versionDetailSuccess,
	[VERSION_DETAILS_ACTIONS.LOAD_VERSION_VARIABLES_ERROR]: versionDetailError,

	[VERSION_DETAILS_ACTIONS.SET_VARIABLE_SEARCH_TERM]: initVersionDetailSearchTerm,
	[VERSION_DETAILS_ACTIONS.SELECT_VERSION_TYPES]: setSelectedTypes,

	[VERSION_DETAILS_ACTIONS.FETCH_VERSION_INFO_AJAX]:initVersionInfo,
	[VERSION_DETAILS_ACTIONS.FETCH_VERSION_INFO_SUCCESS]:successVersionInfo,
	[VERSION_DETAILS_ACTIONS.FETCH_VERSION_INFO_ERROR]:errorVersionInfo,

	[VERSION_DETAILS_ACTIONS.UPDATE_VERSION_VARIABLES_AJAX]:initSavingVariables,
	[VERSION_DETAILS_ACTIONS.UPDATE_VERSION_VARIABLES_SUCCESS]:successSavingVariables,
	[VERSION_DETAILS_ACTIONS.UPDATE_VERSION_VARIABLES_ERROR]:errorSavingVariables,
};

let reducerConfig = {
	typeRoot: "VERSION_DETAILS",
	initialState: initialVersionDetailsState,
	actionTypes: VERSION_DETAILS_ACTIONS,
	actionCreators,
	handlers,
};

function initVersionInfo(state, action){
	return { ...state };
}

function successVersionInfo(state, action){
	return {
		...state,
		info:action.payload.data,
	};
}

function errorVersionInfo(state, action){
	return { ...state };
}

function initSavingVariables(state, action){
	return {
		...state,
		isSavingVariables:true,
	};
}
function successSavingVariables(state, action){
	return {
		...state,
		isSavingVariables:false,
	};
}
function errorSavingVariables(state, action){
	return {
		...state,
		isSavingVariables:false,
	};
}

function initVersionDetails(state, action){
	return {
		...state,
		isLoaded:false,
		hasErrorLoading:false,
	};
}

function clearedVersionDetails(state, action){
	return {
		...initialVersionDetailsState,
	};
}

function versionDetailSuccess(state, action){
	let { data } = action.payload;
	// types is dynamic and responsive to the unique 'set' of asset types that exist in the array
	// of asset items.  This unique set could be different for every creative, i.e. [Images,Videos], or
	// [Image,Video,Text,Richload]. types is used for declaring the toggle buttons.
	let types = new Set(data.map(obj=> obj.type));
	let items = data.map((obj) => {
		if(obj.type === ASSET_TYPES.TEXT && obj.assetId){
			return {
				...obj,
				label: `${obj.prop} (${obj.assetId})`,
			};
		}
		return obj;
	});
	return {
		...state,
		types:[...types],  // spreading the set stores types as an array
		selectedTypes:[],
		// items:data,
		items,
		isLoaded: true,
		hasErrorLoading: false,
	};
}

function versionDetailError(state, action){
	return {
		...state,
		isLoaded: false,
		hasErrorLoading: true,
	};
}

function initVersionDetailSearchTerm(state, action){
	return{
		...state,
		searchTerm:action.payload,
	};
}

function setSelectedTypes(state, action){
	let selections = new Set(state.selectedTypes)
		, varType = action.payload
	;
	// converting the array to a set and then spreading into state reduces the
	// need for if/then blocks that contain filter/map/findIndexOf array methods.
	selections.has(varType) ? selections.delete(varType) : selections.add(varType);

	return{
		...state,
		selectedTypes:[...selections],
	};
}

export default createReducer(reducerConfig.initialState, reducerConfig.handlers);
export const VersionDetails = reducerConfig.actionCreators;
